// Phase 6.C — 작업일정 / 퇴근 체크리스트 sub-route.
// 시안 design/v3/SchedulePage.jsx SECTIONS[4] (id="closing", isResponse=true).

import { AlertBanner, EmptyState } from '../../components/primitives';
import { useViewport } from '../../lib/useViewport';
import { findSection } from './data';
import { SectionCard } from './SectionCard';

export function ScheduleClosingRoute() {
  const isMobile = useViewport() === 'mobile';
  const section = findSection('closing');
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      <AlertBanner
        tone="info"
        message="퇴근 체크리스트 — 링크 발송 → 직원 응답 수신. Phase 7 응답 수신 인프라 도입 후 활성."
      />
      {section ? (
        <SectionCard section={section} isMobile={isMobile} />
      ) : (
        <EmptyState
          icon="check-circle"
          title="등록된 퇴근 체크리스트가 없습니다"
          description="작업일정은 사장/직원이 직접 등록하는 회사별 격리 영역입니다. Phase 7 backend 도입 후 등록 + 발송 + 응답 수신이 활성됩니다."
        />
      )}
    </div>
  );
}
